<template>
    <div>

        <navbar></navbar>

        <div class="bg-header-round-small">
            <div class="container">
                <h1>AGBs für Händler</h1>
            </div>
        </div>

        <section class="container">
            <div class="flex mb-4 flex-wrap">
                <div class="w-1/2">
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aperiam beatae commodi cupiditate delectus
                    dolore dolorem eius enim illum officia, voluptates. Ad aliquid amet animi, libero magnam perferendis
                    quia soluta voluptate.
                </div>
                <div class="w-1/2">
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aperiam doloremque, inventore perferendis
                    porro qui ullam. Adipisci dolorum hic necessitatibus nulla. Minus, nulla, suscipit. Corporis
                    cupiditate dolorum obcaecati! A, eos, optio!
                </div>
            </div>
        </section>

        <cgfooter></cgfooter>

    </div>
</template>

<script>
  import Navbar from '@/components/Navbar.vue'
  import CgFooter from '@/components/CgFooter.vue'

  export default {
    name: 'serviceAgbPartner',
    components: {
      'navbar': Navbar,
      'cgfooter': CgFooter
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/service/AgbPartner.vue